const getTime = () => {
  const date = new Date();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return `${hours}${minutes < 10 ? ":0" : ":"}${minutes}${
    seconds < 10 ? ":0" : ":"
  }${seconds}`;
};

const welcomeMessage = [
  "Welcome to the EasyDB Terminal!",
  {
    time: getTime(),
    type: "info",
    label: "Version:",
    content: "1.0.0",
  },
  {
    time: getTime(),
    type: "info",
    label: "Author:",
    content: "Yuxuan Dai",
  },
  {
    time: getTime(),
    type: "warning",
    label: "System:",
    content: "使用之前请先输入 `init` 初始化数据库。",
  },
  {
    time: getTime(),
    type: "warning",
    label: "System:",
    content: "输入 `SQL` 查看演示命令。",
  },
  {
    time: getTime(),
    type: "warning",
    label: "System:",
    content: "输入 `document` 查看数据库文档。",
  },
  {
    time: getTime(),
    type: "warning",
    label: "System:",
    content: "如出现问题请可以尝试刷新页面。",
  },
];

const introduction = [
  {
    type: "info",
    label: "Name:",
    content: "Yuxuan Dai",
  },
  {
    type: "info",
    label: "Sex:",
    content: "Male",
  },
  {
    type: "info",
    label: "Age:",
    content: "23",
  },
  {
    type: "info",
    label: "Email:",
    content: "blockClothSword@Gmail.com",
  },
];

export default {
  welcome: {
    description: "Welcome message with system introduction.",
    run(print) {
      let i = 0;
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          print(welcomeMessage[i]);
          i++;
          if (!welcomeMessage[i]) {
            clearInterval(interval);
            resolve({
              type: "success",
              label: "Done",
              content: "Welcome to EasyDB!",
            });
          }
        }, 280);
      });
    },
  },
  intro: {
    description: "Introducting myself again.",
    run(print) {
      let i = 0;
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          print(introduction[i]);
          i++;
          if (!introduction[i]) {
            clearInterval(interval);
            resolve({
              type: "success",
              label: "Done",
              content: "Myself introduction is over!",
            });
          }
        }, 500);
      });
    },
  },
  echo: {
    description: "Echoes input.",
    run(print, input) {
      return new Promise((resolve) => {
        print({
          time: getTime(),
          label: "Echo",
          type: "success",
          content: input,
        });
        resolve({ type: "success", label: "", content: "" });
      });
    },
  },
  open: {
    description: "Open a specified url in a new tab.",
    run(print, input) {
      return new Promise((resolve) => {
        if (!input) {
          resolve({
            type: "error",
            label: "Error",
            content: "a url is required!",
          });
          return;
        }
        if (!input.startsWith("http")) {
          resolve({
            type: "error",
            label: "Error",
            content: "Please add `http` prefix!",
          });
          return;
        }
        print({ type: "success", label: "Success", content: "Opening" });

        window.open(input, "_blank");
        resolve({ type: "success", label: "Done", content: "Page Opened!" });
      });
    },
  },
  blog: {
    description: "Open my blog in a new tab.",
    run(print) {
      return new Promise((resolve) => {
        print({ type: "success", label: "Success", content: "Opening" });
        window.open("https://blockcloth.cn", "_blank");
        resolve({ type: "success", label: "Done", content: "blog" });
      });
    },
  },
  document: {
    description: "Consult the database documentation.",
    run(print) {
      return new Promise((resolve) => {
        print({ type: "success", label: "Success", content: "Opening" });
        window.open("http://easydb.blockcloth.cn/", "_blank");
        resolve({ type: "success", label: "Done", content: "document" });
      });
    },
  },
  sql: {
    description: "查看SQL核心功能并执行命令。",
    run(print, input) {
      return new Promise((resolve) => {
        // 简化后的核心功能指南
        const guideContent = `
基本操作：
1. CREATE TABLE users (id INT AUTO_INCREMENT PRIMARY KEY,username VARCHAR NOT NULL,email VARCHAR UNIQUE);
2. INSERT INTO users (username, email) VALUES ('Alice', 'alice@qq.com');
3. SELECT * FROM users;
4. UPDATE users SET email = 'alice@newdomain.com' WHERE username = 'Alice';
5. DELETE FROM users WHERE username = 'Alice';
事务操作：
1. begin;
2. INSERT INTO users (username, email) VALUES ('Smith', 'smith@example.com');
3. SELECT * FROM users;
4. commit;`;

        // 打印指南内容
        print({
          time: getTime(),
          label: "SQL指南",
          type: "info",
          content: guideContent,
        });

        if (input) {
          // 模拟执行输入的SQL命令并输出结果
          const simulatedOutput = `执行 SQL 命令: ${input}\n结果: 模拟的执行结果`;

          print({
            time: getTime(),
            label: "SQL 执行",
            type: "info",
            content: simulatedOutput,
          });
        }

        resolve({
          type: "success",
          label: "完成",
          content: "注：请先选中内容，然后按住 Ctrl + C 进行复制，注意不要松开选择！SQL指南输出完毕！",
        });
      });
    },
  },
};
